import React from 'react';
import PropTypes from 'prop-types';
import GriffPropTypes, { dataPointPropType, accessorFuncPropType, scaleFuncPropType } from '../../utils/proptypes';
import { boundedSeries } from '../../utils/boundedseries';
var propTypes = {
  data: PropTypes.arrayOf(dataPointPropType).isRequired,
  drawPoints: GriffPropTypes.drawPoints,
  xAccessor: accessorFuncPropType.isRequired,
  x0Accessor: accessorFuncPropType,
  x1Accessor: accessorFuncPropType,
  yAccessor: accessorFuncPropType.isRequired,
  y0Accessor: accessorFuncPropType,
  y1Accessor: accessorFuncPropType,
  xScale: scaleFuncPropType.isRequired,
  yScale: scaleFuncPropType.isRequired,
  color: PropTypes.string.isRequired,
  opacity: PropTypes.number,
  opacityAccessor: PropTypes.func,
  pointFilter: PropTypes.func,
  pointWidth: PropTypes.number,
  pointWidthAccessor: PropTypes.func,
  strokeWidth: PropTypes.number
};
var defaultProps = {
  drawPoints: false,
  opacity: 1,
  opacityAccessor: null,
  pointFilter: function pointFilter() {
    return true;
  },
  pointWidth: null,
  pointWidthAccessor: null,
  strokeWidth: null,
  x0Accessor: null,
  x1Accessor: null,
  y0Accessor: null,
  y1Accessor: null
};

var defaultMinMaxAccessor = function defaultMinMaxAccessor() {
  return undefined;
};

var Points = function Points(_ref) {
  var data = _ref.data,
      drawPoints = _ref.drawPoints,
      xAccessor = _ref.xAccessor,
      x0Accessor = _ref.x0Accessor,
      x1Accessor = _ref.x1Accessor,
      yAccessor = _ref.yAccessor,
      y0Accessor = _ref.y0Accessor,
      y1Accessor = _ref.y1Accessor,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      color = _ref.color,
      opacity = _ref.opacity,
      opacityAccessor = _ref.opacityAccessor,
      pointFilter = _ref.pointFilter,
      pointWidth = _ref.pointWidth,
      pointWidthAccessor = _ref.pointWidthAccessor,
      strokeWidth = _ref.strokeWidth;

  if (drawPoints === false) {
    return null;
  }

  var points = data.filter(pointFilter).map(function (d, i, arr) {
    var _map = [xAccessor, x0Accessor || defaultMinMaxAccessor, x1Accessor || defaultMinMaxAccessor].map(function (f) {
      return +boundedSeries(xScale(f(d)));
    }),
        x = _map[0],
        x0 = _map[1],
        x1 = _map[2];

    var _map2 = [yAccessor, y0Accessor || defaultMinMaxAccessor, y1Accessor || defaultMinMaxAccessor].map(function (f) {
      return +boundedSeries(yScale(f(d)));
    }),
        y = _map2[0],
        y0 = _map2[1],
        y1 = _map2[2];

    var width = 0;

    if (pointWidthAccessor) {
      width = pointWidthAccessor(d, i, arr);
    } else if (pointWidth !== undefined && pointWidth !== null) {
      width = pointWidth;
    } else if (strokeWidth !== undefined && strokeWidth !== null) {
      width = strokeWidth;
    } else {
      width = 6;
    }

    var uiElements = [];

    if (!Number.isNaN(x0) && !Number.isNaN(x1)) {
      uiElements.push(React.createElement('line', {
        key: 'horizontal-' + x0 + ',' + y + '-' + x1 + ',' + y,
        x1: x0,
        y1: y,
        x2: x1,
        y2: y,
        stroke: color,
        strokeWidth: 1
      }));
    }

    if (!Number.isNaN(y0) && !Number.isNaN(y1)) {
      uiElements.push(React.createElement('line', {
        key: 'vertical-' + x + ',' + y0 + '-' + x + ',' + y1,
        x1: x,
        y1: y0,
        x2: x,
        y2: y1,
        stroke: color,
        strokeWidth: 1
      }));
    }

    if (!Number.isNaN(x) && !Number.isNaN(y)) {
      uiElements.push(React.createElement('circle', {
        key: x + '-' + y,
        className: 'point',
        r: width / 2,
        opacity: opacityAccessor ? opacityAccessor(d, i, arr) : opacity,
        cx: x,
        cy: y,
        fill: color
      }));
    }

    if (typeof drawPoints === 'function') {
      var metadata = {
        x: x,
        y: y,
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1,
        color: color,
        opacity: opacity,
        opacityAccessor: opacityAccessor,
        pointWidth: pointWidth,
        pointWidthAccessor: pointWidthAccessor,
        strokeWidth: strokeWidth
      };
      return drawPoints(d, i, arr, metadata, uiElements);
    }

    return uiElements;
  });
  return React.createElement('g', null, points);
};

Points.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Points.defaultProps = defaultProps;
export default Points;